import { connect, ConnectedProps } from 'react-redux'
import TableCustomersB2B from '../../../../../../../../specificComponents/Customers/TableCustomersB2B'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { EmployeesPayload } from '../../../../../../../../utils/reducers/company/employees'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { ModalFullCentered, CloseLateralModalSimple } from '../../../../../../../Modal'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'

type CustomersB2BListingModalProps = ReduxTableCustomersB2B & ModalEditComponentProps & {}

const CustomersB2BListingModal: React.FC<CustomersB2BListingModalProps> = ({...rest}) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
            <TableCustomersB2BConnect setTableInstance={() => { }} userPermissions={getUserPermissions('customer.profile.main') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={() => rest.setOpened(null)}/>
        </ModalFullCentered>
    )
}

const tableCustomersB2BDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

type ReduxTableCustomersB2B = ConnectedProps<typeof tableCustomersB2BConnect>
const mapTableCustomersB2BConnector = (state: AllReduxPayloads) => ({ employees: state.employees })
const tableCustomersB2BConnect = connect(mapTableCustomersB2BConnector, tableCustomersB2BDispatch)
const tableCustomersB2BLoading = withLoading(TableCustomersB2B, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])
const TableCustomersB2BConnect = tableCustomersB2BConnect(tableCustomersB2BLoading)


export default CustomersB2BListingModal